import CalendarSuccessSVG from "@design-system/ui-icons/vanilla/CalendarSuccess"
import { createIcon } from "../createIcon"

export const CalendarSuccessIcon = createIcon(CalendarSuccessSVG)
